// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"edit_buttonContainer__OkCh1","saveButton":"edit_saveButton__2w5xW","userEmail":"edit_userEmail__wb2b3"};